import { FormattedMessage } from 'react-intl';
import { LoadingButton, type LoadingButtonProps } from '@mui/lab';
import { Delete } from 'components/icons';

export type DeleteButtonProps = LoadingButtonProps & {
  labelId?: string;
};

const DeleteButton = ({labelId = 'button.delete', ...props} : DeleteButtonProps) : JSX.Element => {
  return (
    <LoadingButton variant='contained' startIcon={<Delete />} color='error' {...props}>
      <FormattedMessage id={labelId} />
    </LoadingButton>
  );
};

export default DeleteButton;